export function createSchema(schema) {
    return schema;
}
//# sourceMappingURL=createSchema.js.map